<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full bg-img vx -row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col max-w-screen-sm">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/newIklient/loginImg.png"
                width="491.09px"
                height="341.98px"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <img
                    :src="iklientLogoSVG"
                    class="object-contain h-12 mx-auto mb-4 lg:hidden xl:hidden"
                  />
                  <h1
                    class="mb-4 text-primary hidden xs:hidden sm:hidden lg:block xl:block"
                  >{{$t('login.login')}}</h1>
                  <p>{{$t('login.welcomeLogin')}}</p>
                </div>
                <form @click.prevent>
                  <vs-input
                    name="username"
                    icon="icon icon-user"
                    icon-pack="feather"
                    :label-placeholder="$t('login.emailOrUserName')"
                    v-model="username"
                    v-validate.disable="'required'"
                    class="w-full no-icon-border"
                    autofocus
                    type="text"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('username')"
                  >{{ errors.first('username') }}</span>

                  <vs-input
                    type="password"
                    name="password"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    :label-placeholder="$t('login.password')"
                    v-model="password"
                    v-validate.disable="'required'"
                    class="w-full mt-6 no-icon-border"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('password')"
                  >{{ errors.first('password') }}</span>
                  <span class="text-danger text-sm">{{this.errMsg}}</span>
                  <div class="flex flex-col my-5">
                    <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox> -->
                    <!-- <router-link to="#">Forgot Password?</router-link> -->
                    <!-- <small>
                      <a
                        href="javascript:void(0)"
                        @click="registerUser"
                      >Zadat SMS kód (registrace, reset hesla, vyplnit formulář)</a>
                    </small>-->
                    <small>
                      <a
                        href="javascript:void(0)"
                        @click="forgottenPassword"
                      >{{$t('login.forgottenPassword')}}</a>
                    </small>
                  </div>
                  <div>
                    <!-- <vs-button type="border">Registrovat</vs-button> -->
                    <vs-button class="w-full" @click.prevent="submitLogin">{{$t('login.signIn')}}</vs-button>
                    <div class="pt-4 pb-4 text-center">
                      <p>{{$t('login.or')}}</p>
                    </div>
                    <vs-button
                      class="w-full"
                      color="warning"
                      @click.prevent="fillSMSCode"
                    >{{$t('login.smsCode')}}</vs-button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <!-- <vs-popup title="Špatná verze Safari nebo iOS" :active.sync="disableUI">
      <div class="flex flex-col">
        <span
          class="mb-base"
        >Na této verzi Safari se pravděpodobně do aplikace nepřihlásíte. Proto Vám doporučujeme aktualizovat iOS na novější verzi.</span>
        <vs-button
          class="w-1/4"
          style="justify-self:flex-end; align-self:flex-end;"
          @click="disableUI = false"
        >Rozumím</vs-button>
      </div>
    </vs-popup>-->
  </div>
</template>

<script>
import { RepositoryFactory } from "../../api/RepositoryFactory";
const UserCalls = RepositoryFactory.get("user");
import { Validator } from "vee-validate";

const dict = {
  custom: {}
};

export default {
  data() {
    return {
      username: "",
      password: "",
      checkbox_remember_me: false,
      token: "",
      disableUI: false,
      errMsg: "",
      iklientLogoSVG: require("@/assets/images/newIklient/iklientLogo.svg")
    };
  },
  mounted() {
    if (this.$route.params.err) {
      if (this.$route.params.err === "err401") {
        this.$vs.notify({
          title: this.$t("login.signOut"),
          text: this.$t("login.signedOut"),
          color: "warning"
        });
      } else if (this.$route.params.err === "badCode") {
        this.$vs.notify({
          title: this.$t("error"),
          text: this.$t("login.codeVerifyError"),
          color: "danger"
        });
      }
    }
  },
  created() {
    this.$store.dispatch("resetStore");
    if (this.$route.params["username"]) {
      this.username = this.$route.params["username"];
    }
  },
  methods: {
    forgottenPassword() {
      this.$router.push({ name: "pageForgottenPassword" });
    },
    goSettings() {
      location.href = "App-prefs:root=General";
    },
    disableSafari(v) {
      const ua = navigator.userAgent;
      if (ua.includes(`/${v} Safari/`) || ua.includes(`/${v} Mobile/`)) {
        return true;
      }

      return false;
    },

    fillSMSCode() {
      this.$router.push({ name: "pageRegister" });
    },
    submitLogin() {
      this.errMsg = "";
      this.$vs.loading();
      this.$validator.validateAll().then(result => {
        if (result) {
          UserCalls.authUser(this.username, this.password)
            .then(({ data }) => {
              localStorage.setItem("token", JSON.stringify(data));
              this.token = data;
              this.$vs.loading.close();

              this.$router.push({ name: "home", params: { confirm: true } });
            })
            .then(() => {})
            .catch(err => {
              this.$vs.loading.close();
              (this.password = ""),
                // this.$vs.notify({
                //   title: this.$t("error"),
                //   text: this.$t("login.badLogin"),
                //   color: "danger"
                // });
                (this.errMsg = this.$t("login.badLogin"));
            });
        } else {
          this.$vs.loading.close();
          // this.$vs.notify({
          //   title: this.$t("error"),
          //   text: this.$t("login.badDataLogin"),
          //   color: "danger"
          // });
        }
      });
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}

// .vx-card {
//   width: 800px;
//   max-width: 800px;
// }
</style>
